import React, { memo } from "react";
import UserActivityBarChart from "./UserActivityBarChart";

const convertTimeSpent = (time) => {
  if (!time || time <= 0) return "0m";

  const totalMinutes = Math.floor(time);

  const days = Math.floor(totalMinutes / 1440);
  const hours = Math.floor((totalMinutes % 1440) / 60);
  const minutes = totalMinutes % 60;

  const parts = [];
  if (days) parts.push(`${days}d`);
  if (hours) parts.push(`${hours}h`);
  if (minutes) parts.push(`${minutes}m`);

  return parts.join(" ") || "0m";
};

const UserActivityCard = memo(({
  title,
  showFilter = false,
  filterComponent = null,
  chartData,
  grouping
}) => {
  // Add null/undefined checks to prevent crashes
  // if (!chartData || !Array.isArray(chartData) || chartData.length === 0) {
  //   return (
  //     <div className="userActivityCard">
  //       {title && <div className="activityCard__title">{title}</div>}
  //       <div className="activityCard__content">
  //         <div className="activityCard__header">
  //           <div className="activityStats">
  //             <div className="activityStats__item">
  //               Daily Average
  //               <span className="activityStats__value">-</span>
  //             </div>
  //             <div className="activityStats__item">
  //               Total Time
  //               <span className="activityStats__value">-</span>
  //             </div>
  //           </div>
  //           {showFilter && (
  //             <div className="activityCard__filter">
  //               {filterComponent}
  //             </div>
  //           )}
  //         </div>
  //         <div className="activityCard__chart">
  //           <div style={{ padding: "20px", textAlign: "center", color: "#999" }}>
  //             No data available
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // }
  
  const total = chartData.reduce((sum, item) => {
    return (
      sum +
      Object.entries(item)
        .filter(([key]) => key !== "day" && key !== "month" && key !== "totalDays")
        .reduce((s, [, value]) => s + (typeof value === 'number' ? value : 0), 0)
    );
  }, 0);

  let divider = chartData.length;

if (grouping === "month" && chartData.length > 0) {
  divider = chartData.reduce(
    (sum, item) => sum + (item.totalDays || 0),
    0
  );
}

console.log("Divider for average calculation:", divider, "Grouping:", grouping, total);

const average = divider > 0 ? Number((total / divider).toFixed(2)) : 0;

  return (
    <div className="userActivityCard">
      {title && (<div className="activityCard__title">{title}</div>)}

      <div className="activityCard__content">
        <div className="activityCard__header">
          <div className="activityStats">
            <div className="activityStats__item">
              Daily Average
              <span className="activityStats__value">{convertTimeSpent(average)}</span>
            </div>

            <div className="activityStats__item">
              Total Time
              <span className="activityStats__value">{convertTimeSpent(total)}</span>
            </div>
          </div>

          {showFilter && (
            <div className="activityCard__filter">
              {filterComponent}
            </div>
          )}
        </div>

        <div className="activityCard__chart">
          <UserActivityBarChart data={chartData} type={title} grouping={grouping}/>
        </div>
      </div>
    </div>
  );
});

UserActivityCard.displayName = 'UserActivityCard';

export default UserActivityCard;
